import I18n from 'I18n';
import * as messageActions from 'automation-ui-canvas/actions/MessageActions';
import { PASTE_FAILED, PASTE_NO_ACTION_FAILURE, PASTE_OBJECT_MISMATCH_FAILURE, PASTE_ACTION_MISMATCH_FAILURE } from 'automation-ui-canvas/constants/AlertTypes';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import PortalIdParser from 'PortalIdParser';
const canPasteRejectionReasons = {
  PASTE_FAILED,
  PASTE_NO_ACTION_FAILURE,
  PASTE_OBJECT_MISMATCH_FAILURE,
  PASTE_ACTION_MISMATCH_FAILURE
};
function canPaste({
  flowObjectTypeId,
  copiedData,
  flow
}) {
  if (copiedData && 'error' in copiedData) {
    return {
      canPaste: false,
      reason: canPasteRejectionReasons.PASTE_FAILED
    };
  }
  if (!copiedData || 'portalId' in copiedData && copiedData.portalId !== PortalIdParser.get()) {
    return {
      canPaste: false,
      reason: canPasteRejectionReasons.PASTE_NO_ACTION_FAILURE
    };
  }
  if (flowObjectTypeId !== copiedData.flowObjectTypeId) {
    return {
      canPaste: false,
      reason: canPasteRejectionReasons.PASTE_OBJECT_MISMATCH_FAILURE
    };
  }
  const isDateBasedFLow = !!flow.getClassicEnrollmentSettings() && !!flow.getClassicEnrollmentSettings().eventAnchor;
  const platformDelayActions = [ActionTypes.DELAY, ActionTypes.DELAY_UNTIL_DATE];
  const isClassicDelayMismatch = copiedData.action.getActionType() === ActionTypes.CLASSIC_ANCHORED_DELAY && !isDateBasedFLow;
  const isPlatformDelayMismatch = platformDelayActions.includes(copiedData.action.getActionType()) && isDateBasedFLow;
  if (isClassicDelayMismatch || isPlatformDelayMismatch) {
    return {
      canPaste: false,
      reason: canPasteRejectionReasons.PASTE_ACTION_MISMATCH_FAILURE
    };
  }
  return {
    canPaste: true
  };
}
export function canPasteActionWithAlert({
  flowObjectTypeId,
  copiedData,
  flow,
  dispatch
}) {
  const {
    canPaste: pastable,
    reason
  } = canPaste({
    flowObjectTypeId,
    copiedData,
    flow
  });
  if (!pastable) {
    switch (reason) {
      case canPasteRejectionReasons.PASTE_NO_ACTION_FAILURE:
        dispatch(messageActions.addAlert(PASTE_NO_ACTION_FAILURE));
        break;
      case canPasteRejectionReasons.PASTE_OBJECT_MISMATCH_FAILURE:
        dispatch(messageActions.addAlert(PASTE_OBJECT_MISMATCH_FAILURE));
        break;
      case canPasteRejectionReasons.PASTE_ACTION_MISMATCH_FAILURE:
        dispatch(messageActions.addAlert(PASTE_ACTION_MISMATCH_FAILURE));
        break;
      default:
      case canPasteRejectionReasons.PASTE_FAILED:
        dispatch(messageActions.addAlert(PASTE_FAILED));
        break;
    }
  }
  return pastable;
}
export function canPasteAction({
  flowObjectTypeId,
  copiedData,
  flow
}) {
  const {
    canPaste: pastable,
    reason
  } = canPaste({
    flowObjectTypeId,
    copiedData,
    flow
  });
  if (pastable) {
    return {
      canPaste: pastable
    };
  }
  switch (reason) {
    case canPasteRejectionReasons.PASTE_NO_ACTION_FAILURE:
      return {
        canPaste: pastable,
        errorMessage: I18n.text('alerts.paste.noActionError.body')
      };
    case canPasteRejectionReasons.PASTE_OBJECT_MISMATCH_FAILURE:
      return {
        canPaste: pastable,
        errorMessage: I18n.text('alerts.paste.objectTypeMismatch.body')
      };
    case canPasteRejectionReasons.PASTE_ACTION_MISMATCH_FAILURE:
      return {
        canPaste: pastable,
        errorMessage: I18n.text('alerts.paste.actionMismatch.body')
      };
    default:
    case canPasteRejectionReasons.PASTE_FAILED:
      return {
        canPaste: false,
        errorMessage: I18n.text('alerts.paste.genericError.body')
      };
  }
}